import React from "react";
import { Link } from "react-router-dom";
import { Compass, ArrowRight, Sparkles } from "lucide-react";

export default function QuizCTA() {
  return (
    <section
      data-testid="quiz-cta-section"
      className="relative py-20 md:py-28 bg-gradient-to-br from-[#0B192C] via-[#173F5F] to-[#0E7C8F] text-[#F9F8F6] overflow-hidden"
    >
      {/* Decorative compass watermark */}
      <Compass
        size={520}
        strokeWidth={0.4}
        className="absolute -right-32 -top-20 text-[#E89B6C]/8 pointer-events-none"
      />

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 grid md:grid-cols-[2fr,1fr] gap-10 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 border border-[#E89B6C]/40 bg-[#E89B6C]/10 mb-6">
            <Sparkles size={14} className="text-[#E89B6C]" />
            <span className="overline text-[#E89B6C]">Test gratuito · 3 minuti</span>
          </div>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
            Non sai da dove <em className="text-[#E89B6C]">iniziare</em>?
            <br />
            Trova la tua rotta in 3 minuti.
          </h2>
          <p className="mt-6 max-w-xl text-base md:text-lg font-light text-[#F9F8F6]/80 leading-relaxed">
            5 domande veloci. In cambio ricevi una <strong className="font-medium text-[#F9F8F6]">diagnosi personalizzata</strong>,
            i prossimi 3 passi concreti da fare, e l&apos;accesso gratuito all&apos;Area Iscritti
            con i 3 corsi del Metodo di Mare.
          </p>
        </div>

        <div className="flex flex-col items-start md:items-end gap-4">
          <Link
            to="/quiz"
            data-testid="landing-quiz-cta"
            data-track="quiz-cta"
            className="group inline-flex items-center gap-3 px-8 py-5 bg-[#E89B6C] text-[#0B192C] text-xs uppercase tracking-[0.2em] hover:bg-[#F9F8F6] transition-all"
          >
            Inizia il test
            <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
          </Link>
          <p className="text-[10px] uppercase tracking-[0.18em] text-[#F9F8F6]/50">
            Nessun obbligo · 1 click per disiscriversi
          </p>
        </div>
      </div>
    </section>
  );
}
